export class MoldMaterial {
    id: number;
    name: string;
}

